<template>
	<Popper
		v-click-outside="closePopover"
		:isVisible="popoverVisible"
		placement="bottom-end"
		@keyup.escape="closePopover"
	>
		<BaseTooltip text="Developer Tool Settings" :enabled="!popoverVisible" placement="bottom-end">
			<BaseButton
				class="hover:bg-gray-650 text-gray-300 h-28 w-28 rounded flex items-center justify-center"
				@click="togglePopover"
			>
				<BaseIcon name="mono/settings" />
			</BaseButton>
		</BaseTooltip>
		<template #popup>
			<BasePopover title="Developer Tool Settings" style="width: auto">
				<div class="flex items-center justify-between popover-link">
					<label class="text-gray-300 cursor-pointer" for="wrap-text"> Wrap text </label>
					<BaseSwitch id="wrap-text" v-model="$sessionLayout.wrapDevToolsText" />
				</div>
				<div class="flex items-center justify-between popover-link">
					<label class="text-gray-300 cursor-pointer mr-16" for="scroll-with-playback">
						Auto-scroll with playback
					</label>
					<BaseSwitch id="scroll-with-playback" v-model="$sessionLayout.scrollDevToolsWithPlayback" />
				</div>
				<button
					v-if="$store.hasUserAdminRole"
					class="px-12 text-gray-300 popover-link"
					@click="
						$routerHelpers.navigateToWorkspaceSettings('general', {
							hash: '#data-redaction',
						})
					"
				>
					Data recording options
				</button>

				<template #footer>
					<a
						href="https://docs.birdeatsbug.com/latest/reports/devtools.html"
						target="_blank"
						rel="noreferrer"
						class="px-12 mt-4 block text-gray-300 popover-link"
					>
						Developer Tools FAQ
						<BaseIcon name="mono/arrow" class="w-10 h-10 mt-4 float-right" />
					</a>
				</template>
			</BasePopover>
		</template>
	</Popper>
</template>

<script>
import Popper from 'shared/components/Popper.vue'
import {useSessionStore} from 'shared/stores/session'

export default {
	name: 'SessionDevToolSettingsPopover',
	components: {
		Popper,
	},
	setup() {
		return {sessionStore: useSessionStore()}
	},
	data() {
		return {
			popoverVisible: false,
		}
	},
	computed: {},
	methods: {
		closePopover() {
			this.popoverVisible = false
		},
		togglePopover() {
			this.popoverVisible = !this.popoverVisible
		},
	},
}
</script>
